<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16vadNI/tc-custom/9781439673294.jpg?1737918819401" alt="This image is the cover for the book Pullman"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pullman
      </h1>
      <p class="bookDescription body article font2">
        <p>George Pullman's legacy lies in the town that bears his name. As one of the first thoroughly planned model industrial communities, it was designed to give the comforts of a permanent home to the employees who built America's most elegant form of overnight railroad travel. But the town was more than just a residential wing of sleeper car manufacturing; its 1894 railroad strike led to the national Labor Day holiday. In the early twentieth century, the Pullman Company became the country's largest employer of African Americans, who then formed the nation's first successful Black labor union. Author Kenneth Schoon revisits Pullman's monumental history and the lessons it continues to provide.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kenneth J Schoon
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b4b3b8e